import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "bg-primary h-screen w-screen flex justify-center items-center" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center gap-6 md:gap-10"
}
const _hoisted_3 = { class: "text-sm md:text-base text-white text-center w-64 md:w-80" }
const _hoisted_4 = { class: "flex flex-col items-center gap-2 md:gap-3" }

import { useAction } from "@/utils/vuex-hooks";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import Button from "../atoms/Button.vue";
import Icon from "../atoms/Icon.vue";
import LangSelection from "../organisms/LangSelection.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(false);
const selectInitMute = useAction("selectInitMute");
const validate = (value: boolean) => {
  loading.value = true;
  selectInitMute(value);
};

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "quick-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(LangSelection),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("welcome.message")), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(Button, {
                  color: "default",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (validate(true))),
                  "fixed-width": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("welcome.accept")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  color: "secondary",
                  small: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (validate(false))),
                  "fixed-width": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("welcome.deny")), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : (loading.value)
            ? (_openBlock(), _createBlock(Icon, {
                key: 1,
                name: "spinner",
                size: "m",
                class: "animate-spin"
              }))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})